import React from 'react';

import useZenMode from '../../hooks/useZenMode';
import { HeaderSpacerBox } from './styles';

// In zen mode there is no app bar to clear, so the view opens at the top edge.
export default function HeaderSpacer() {
  const zenMode = useZenMode();
  if (zenMode) return null;
  return <HeaderSpacerBox />;
}
